var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 30.5C0 13.937 13.437 0.5 30 0.5C46.563 0.5 60 13.937 60 30.5C60 47.063 46.563 60.5 30 60.5C13.437 60.5 0 47.063 0 30.5ZM55.3844 30.5C55.3844 16.4861 44.0138 5.1154 29.9998 5.1154C15.9858 5.1154 4.61517 16.4861 4.61517 30.5C4.61517 44.514 15.9858 55.8846 29.9998 55.8846C44.0138 55.8846 55.3844 44.514 55.3844 30.5Z",
    fill: "url(#paint0_linear_113_297)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2183 17.5584C41.0232 16.6003 42.4523 16.4761 43.4104 17.2809C44.3555 18.0748 44.4892 19.4763 43.7201 20.4338L43.6879 20.4729L24.6567 43.1292C23.7819 44.1705 22.1969 44.2098 21.271 43.2237L21.2379 43.1876L13.0816 34.1251C12.2446 33.195 12.32 31.7625 13.25 30.9254C14.1673 30.0998 15.5735 30.1619 16.4149 31.0561L16.4497 31.0938L22.8628 38.2196L40.2183 17.5584Z",
    fill: "url(#paint1_linear_113_297)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_113_297",
    x1: 30,
    y1: 0.5,
    x2: 30,
    y2: 60.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C46BFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#783CE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_113_297",
    x1: 28.3594,
    y1: 16.75,
    x2: 28.3594,
    y2: 43.9376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C46BFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#783CE9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmed);
export default __webpack_public_path__ + "static/media/confirmed.e55cefd60f464b43d935703d576a38ae.svg";
export { ForwardRef as ReactComponent };